import { base_parse } from './nodes/html';
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */

export default function valid(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    lowerCaseTagName: false,
    comment: false
  };
  var stack = base_parse(data, options);
  return Boolean(stack.length === 1);
}